import { apiSlice } from "@/shared/api/api-slice"
import { chatIdMutation } from "@/shared/api/queries"

import type { UploadCustomImageRequest, UploadCustomImageResponse } from "./card-style-types"
import { getUserCardStyleTag } from "./get-user-card-style"

export const uploadCustomImageApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["UserCardStyle"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      uploadCustomImage: builder.mutation<UploadCustomImageResponse, UploadCustomImageRequest>({
        queryFn: chatIdMutation<UploadCustomImageRequest, UploadCustomImageResponse>((chatId, arg) => {
          const formData = new FormData()
          formData.append("chat_id", String(chatId))
          formData.append("file", arg.file)
          return { url: "/api/v1/card-styles/me/custom-image", method: "PUT", body: formData }
        }),
        invalidatesTags: (_result, error, { chatId }) => (error ? [] : [getUserCardStyleTag(chatId)])
      })
    })
  })

export const { useUploadCustomImageMutation } = uploadCustomImageApi
